import { HeaderModal } from './types';

export const headers: HeaderModal = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  platform: 'web',
  device: 'web',
  'X-Locale': 'de',
};
